__turbopack_context__.v({
  "root": "SiteNotices-module-scss-module__fwTvpa__root",
  "slide": "SiteNotices-module-scss-module__fwTvpa__slide",
  "slideUp": "SiteNotices-module-scss-module__fwTvpa__slideUp",
});
